// Sentry records an error's own properties but only the message of its cause, so the failures move up.
export default function soundLoadError(cause) {
  let error = new Error('failed to load sound', { cause });
  error.failures = cause?.failures;
  return error;
}
